if (!customElements.get('stone-selector')) {
  customElements.define(
    'stone-selector',
    class StoneSelector extends HTMLElement {
      constructor() {
        super();

        this.checkboxes = [...this.querySelectorAll('input[type="checkbox"]')];
        this.limit = 0;
        this.selectedCount = 0;
        this.variantAllowsAdd = true;
        this.countDisplay = this.querySelector('.stone-selector__count');
        this.formId = this.dataset.formId;
        this.sectionId = this.dataset.section;

        this.hiddenInputsContainer = document.createElement('div');
        this.hiddenInputsContainer.style.display = 'none';
        this.appendChild(this.hiddenInputsContainer);

        this.initPedrasListener();
        this.initCheckboxListeners();
        this.initVariantChangeSubscriber();
        this.updateLimitFromVariant();
        this.captureInitialButtonState();
      }

      get variantContainer() {
        return (
          document.querySelector(`variant-radios[data-section="${this.sectionId}"]`) ||
          document.querySelector(`variant-selects[data-section="${this.sectionId}"]`)
        );
      }

      get addButton() {
        const form = document.getElementById(this.formId);
        return form?.querySelector('[name="add"]');
      }

      get addButtonText() {
        return this.addButton?.querySelector('span');
      }

      captureInitialButtonState() {
        const button = this.addButton;
        if (button) {
          this.variantAllowsAdd = !button.hasAttribute('disabled');
        }
        this.updateAddButton();
      }

      initVariantChangeSubscriber() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          const button = this.addButton;
          this.variantAllowsAdd = button && !button.hasAttribute('disabled');
          this.updateAddButton();
        });
      }

      initPedrasListener() {
        const container = this.variantContainer;
        if (!container) return;

        container.addEventListener('change', (e) => {
          const target = e.target;
          const isPedrasRadio = target.type === 'radio' && target.name === 'Pedras';
          const isPedrasSelect =
            target.tagName === 'SELECT' && target.getAttribute('name') === 'options[Pedras]';

          if (isPedrasRadio || isPedrasSelect) {
            this.limit = parseInt(target.value, 10) || 0;
            this.resetSelections();
            this.updateDisplay();
            this.updateAddButton();
          }
        });
      }

      initCheckboxListeners() {
        this.checkboxes.forEach((cb) => {
          cb.addEventListener('change', () => {
            this.updateSelectedCount();
            this.updateCheckboxStates();
            this.syncHiddenInputs();
            this.updateDisplay();
            this.updateAddButton();
          });
        });
      }

      updateLimitFromVariant() {
        const container = this.variantContainer;
        if (!container) return;

        const checkedPedras = container.querySelector('input[name="Pedras"]:checked');
        if (checkedPedras) {
          this.limit = parseInt(checkedPedras.value, 10) || 0;
        } else {
          const pedrasSelect = container.querySelector('select[name="options[Pedras]"]');
          if (pedrasSelect) {
            this.limit = parseInt(pedrasSelect.value, 10) || 0;
          }
        }

        this.updateDisplay();
        this.updateCheckboxStates();
      }

      resetSelections() {
        this.checkboxes.forEach((cb) => {
          cb.checked = false;
          cb.disabled = false;
        });
        this.selectedCount = 0;
        this.syncHiddenInputs();
      }

      updateSelectedCount() {
        this.selectedCount = this.checkboxes.filter((cb) => cb.checked).length;
      }

      updateCheckboxStates() {
        const atLimit = this.limit > 0 && this.selectedCount >= this.limit;
        this.checkboxes.forEach((cb) => {
          cb.disabled = !cb.checked && atLimit;
        });
      }

      updateDisplay() {
        if (this.countDisplay) {
          this.countDisplay.textContent = `(${this.selectedCount}/${this.limit})`;
        }
      }

      updateAddButton() {
        const button = this.addButton;
        if (!button || this.limit === 0) return;

        const buttonText = this.addButtonText;
        const stonesComplete = this.selectedCount >= this.limit;

        if (!stonesComplete) {
          button.setAttribute('disabled', 'disabled');
          if (buttonText) {
            buttonText.textContent = `Selecione suas pedras (${this.selectedCount}/${this.limit})`;
          }
        } else if (!this.variantAllowsAdd) {
          button.setAttribute('disabled', 'disabled');
          if (buttonText) {
            buttonText.textContent = window.variantStrings?.soldOut || 'Esgotado';
          }
        } else {
          button.removeAttribute('disabled');
          if (buttonText) {
            buttonText.textContent = window.variantStrings?.addToCart || 'Adicionar ao carrinho';
          }
        }
      }

      syncHiddenInputs() {
        this.hiddenInputsContainer.innerHTML = '';

        const selected = this.checkboxes.filter((cb) => cb.checked);
        selected.forEach((stone, i) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[Pedra ${i + 1}]`;
          input.value = stone.value;
          input.setAttribute('form', this.formId);
          this.hiddenInputsContainer.appendChild(input);
        });
      }
    }
  );
}
